<template>
  <div
    v-if="ques"
    @click="handleCloseAll"
    :class="ques.can_be_blurred && ques.user[0].id !== authUser.user.id ? 'blur shadow-card ' : 'shadow-card '"
    :style="
      ques.user[0].role === 'doctor' || ques.user[0].role === 'ohcp'
        ? 'background: #F8FEFF'
        : ques.user[0].role === 'admin'
        ? 'background: #EBFCF5'
        : ques.user[0].role === 'nfp_administrator'
        ? 'background: #FFFCF5'
        : ques.user[0].role === 'advocate'
        ? 'background: #FFFFFF'
        : ques.user[0].role === 'hospital_administrator'
        ? 'background: #FFFCF5'
        : ques.user[0].role === 'clinic_administrator'
        ? 'background: #FFFCF5'
        : 'background: #FFFFFF'
    "
  >
    <div class="post-head position-relative mb-2">
      <div class="title">
        <!-- <a @click="viewProfile">
            <a-avatar
              icon="user"
              :size="84"
              :src="ques.user[0].url"
              alt
              class="post-list-image"
            />
          </a> -->

        <a-avatar
          :style="{
            color: ' #ffffff !important',
            'background-color': (ques.user[0].url ? ques.user[0].url : '') ? '' : '#C997C5',
          }"
          @click="viewProfile"
          :src="ques.user[0].url"
          :size="70"
          class="post-list-image text-capitalize cp"
        >
          {{ ques.user[0].firstName ? ques.user[0].firstName[0] : ques.user[0].display_name[0] }}
        </a-avatar>
      </div>
      <div :style="{ marginTop: '10px' }">
        <div @click="viewProfile">
          <p v-if="ques.user[0].role === 'caregiver'" class="m-0 pb-0 pt-2 pl-0 text-capitalize cp">
            {{ ques.user[0].role === "doctor" ? "Dr." + " " + ques.user[0].first_name + " " + ques.user[0].last_name : ques.user[0].display_name ? ques.user[0].display_name : "DoveMed Admin" }}{{ " "
            }}{{ ques.user[0].role === "caregiver" ? "'s patient" : "" }}
            <font-awesome-icon size="2x" style="transform: scale(0.9); width: 30px" class="nav-tab-icons " :icon="['fal', 'question-circle']" />
            <span :style="{ 'font-weight': '400' }">asked a question</span>
          </p>
          <p v-else class="m-0 pb-0 pt-2 pl-0 text-capitalize cp">
            {{ ques.user[0].role === "doctor" ? "Dr." + " " + ques.user[0].first_name + " " + ques.user[0].last_name : ques.user[0].display_name }}{{ " "
            }}{{ ques.user[0].role === "caregiver" ? "'s patient" : "" }}
            <font-awesome-icon size="2x" style="transform: scale(0.9); width: 30px" class="nav-tab-icons " :icon="['fal', 'question-circle']" />
            <span :style="{ 'font-weight': '400' }">asked a question</span>
          </p>
        </div>
        <div>
          <div class="post-physician p-1 pl-2 pr-2 mt-2 mb-2" v-if="ques.user[0].role === 'doctor'" :style="{ color: 'white !important', 'font-size': '10px' }">
            PHYSICIAN ({{ ques.user[0].speciality }})
          </div>
          <div class="post-physician p-1 pl-2 pr-2 mt-2 mb-2" v-if="ques.user[0].role === 'nfp'" :style="{ color: 'white !important', 'font-size': '10px' }">
            NON FOR PROFIT
          </div>
          <div class="post-physician p-1 pl-2 pr-2 mt-2 mb-2" v-if="ques.user[0].role === 'advocate'" style="color: white !important;font-size: 10px">
            <div v-if="ques.user[0].organization">Advocates ({{ ques.user[0].organization }})</div>
            <div v-else>Advocate for {{ currentCircle.condition_type.slice(0, 20) }}{{ currentCircle.condition_type.length > 20 ? "..." : "" }}</div>
          </div>
        </div>
        <p class="posted">{{ formatPostTime(ques.asked_time) }}</p>
      </div>
      <button v-if="!ques.admin_unflagged && ques.user[0].id !== authUser.user.id && ques.user_role !== 'admin'" class="threedot-menu">
        <div class="dot-menu-cont" @click="fetchUser">
          <a-icon type="more" />
          <!-- <div class="dot"></div> -->
        </div>
        <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
          <!-- menu-content shadow-card -->
          <p class="card-item d-flex align-items-center" style="font-weight: 500" @click="showModel(ques)">
            Report Content or Spam
          </p>
          <p v-if="showRemoveCircleOption" class="card-item" @click="() => $refs.removeUserModal.show(ques.user[0])">
            Remove from Circle
          </p>
        </div>
      </button>
      <!-- <div
          class="delete-post-dropdown"
          v-if="
            !ques.admin_unflagged &&
              ques.user[0].id === authUser.user.id &&
              ques.user_role !== 'admin'
          "
        >
          <a-dropdown placement="bottomRight" :trigger="['click']">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <div>
                <a-icon type="more" />
              </div>
            </a>
            <a-menu slot="overlay">
              <a-menu-item key="0">
                <span
                  class="dropdown-text"
                  @click="e => handleDeletePostModal(e, ques)"
                >
                  Delete Question
                </span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div> -->
    </div>
    <b
      style="white-space: pre-wrap"
      class="mb-2 mt-2 "
      :style="{
        'font-weight': '700',
        'font-size': ' 16px',
        'line-height': '24px',
        color: '#0F1734',
      }"
      v-html="ques.question"
    ></b>
    <p style="white-space: pre-wrap" class="mt-2 mb-2 post-description" v-html="ques.question_description"></p>
    <!-- <div v-for="(image, index) in ques.question_attach_url" :key="index"> -->
    <img
      v-if="ques.thumbnail_url ? ques.thumbnail_url[0] : ques.question_attach_url ? ques.question_attach_url[0] : ''"
      :src="ques.thumbnail_url ? ques.thumbnail_url[0] : ques.question_attach_url ? ques.question_attach_url[0] : ''"
      alt
      width="100%"
      class="mb-3"
    />
    <!-- </div> -->
    <!-- <p class="posted">Posted {{ formatPostTime(ques.asked_time) }}</p> -->
    <div v-if="ques.tags" class="post__tags">
      <div
        v-for="(tag, index) in ques.tags.slice(0, 3)"
        :key="index"
        class="tags rounded"
        :style="{
          color: getSecondaryColor(),
          background: getAlphaPrimaryColor(),
        }"
      >
        #{{ tag }}
      </div>
      <div v-if="ques.tags.length > 3" class="popover-button">
        <a-popover placement="right">
          <template slot="content">
            <p
              v-for="(tag, index) in ques.tags.slice(3)"
              :key="index"
              :style="{
                color: getSecondaryColor(),
                background: getAlphaPrimaryColor(),
              }"
            >
              #{{ tag }}
            </p>
          </template>
          <a-button
            :style="{
              background: getAlphaPrimaryColor(),
              color: getSecondaryColor(),
            }"
            >+{{ ques.tags.length - 3 }}
          </a-button>
        </a-popover>
      </div>
    </div>
    <div class="d-flex" :style="{ gap: '50px', flexDrection: 'row' }">
      <!-- <div id="hugs" class="u-options" @click="react(ques, $event)">
          <font-awesome-icon
            size="1x"
            :icon="
              reactions.hugs ? ['fas', 'hands-heart'] : ['fal', 'hands-heart']
            "
            :style="{ color: reactions.hugs ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">
            Embrace ({{ ques.reaction.hugs }})
          </div>
        </div> -->
      <div id="likes" class="u-options" @click="react(ques, $event)">
        <font-awesome-icon size="1x" :icon="reactions.likes ? ['fas', 'heart'] : ['fal', 'heart']" :style="{ color: reactions.likes ? getPrimaryColor() : '' }" />
        <div class="posted-reactions-text" :style="{ 'margin-top': '-3px', cursor: 'default' }">
          Like
          <!-- Like ({{ ques.reaction.likes }}) -->
        </div>
      </div>
      <div class="u-options" @click="">
        <!-- onclick-prev :  comments.length === 0 && fetchComments() -->
        <font-awesome-icon size="1x" :icon="['fal', 'comment-alt']" :style="{ cursor: 'default' }" />
        <div class="posted-reactions-text" :style="{ 'margin-top': '-3px', cursor: 'default' }">
          {{ ques.comments_count }}
          {{ ques.comments_count > 1 ? "Comments" : "Comment" }}
          <!-- Comment ({{ ques.comments_count }}) -->
        </div>
      </div>
      <!-- <div id="favorites" class="u-options" @click="react(ques, $event)">
          <font-awesome-icon
            size="1x"
            :style="{ color: reactions.favorites ? getPrimaryColor() : '' }"
            :icon="
              reactions.favorites ? ['fas', 'bookmark'] : ['fal', 'bookmark']
            "
          />
          <div class="posted-reactions-text">Bookmark</div>
        </div> -->
      <div class="u-options" @click="() => $refs.sharePostModal.show(ques, 3, 'Share Question')">
        <!-- <font-awesome-icon size="1x" :icon="['fal', 'share-alt']" /> -->
        <!-- <font-awesome-icon size="1x" :icon="['fal', 'share']"/> -->
        <img src="../../../../assets/images/share.png" :style="{ width: '20px', height: '15px' }" alt="share" />
        <div class="posted-reactions-text" :style="{ 'margin-top': '-3px' }">Share</div>
      </div>
      <div :style="{ 'margin-left': '285px' }">
        <img src="../../../../assets/images/like.png" alt="like count" :style="{ 'margin-top': '-2px' }" />
        <span>{{ ques.reaction.likes }} </span>
      </div>
    </div>
    <hr v-if="showWritable" />
    <div :style="{ color: getPrimaryColor(), cursor: 'pointer' }" @click="fetchComments(true, true)" v-if="comments.length && ques.comments_count - this.comment_count > 0">
      see {{ ques.comments_count - this.comment_count }} other answers
    </div>
    <div v-if="comments.length">
      <div v-for="(comment, index) in comments" :key="comment.id">
        <Comment :commentData="comment" :index="index"></Comment>
      </div>
      <span
        v-if="comments.length && ques.comments_count - this.comment_count > 0"
        :style="{
          color: getPrimaryColor(),
          textAlign: 'center',
          display: 'block',
          cursor: 'pointer',
        }"
        @click="fetchComments(true, true)"
        >View More</span
      >
    </div>
    <!-- <hr v-if="showWritable" /> -->
    <div class="d-flex">
      <div v-if="showWritable" class="post-comment" style="display: flex; justify-content: space-between;width:100%">
        <div class="title d-flex align-items-center mr-2">
          <!-- <img :src="authUser.user.url" alt class="post-comment-image" /> -->
          <a-avatar
            :style="{
              color: ' #ffffff !important',
              'background-color': authUser.user.url ? '' : '#C997C5',
            }"
            :src="authUser.user.url"
            class="text-capitalize "
            :size="40"
          >
            <!-- {{
                authUser.user.firstName
                  ? authUser.user.firstName[0]
                  : authUser.user.display_name
                  ? authUser.user.display_name[0]
                  : authUser.user.first_name[0]
              }} -->
            {{ getInitials() }}
          </a-avatar>
        </div>
        <a-input placeholder="Add an answer..." v-model="comment" @keyup.enter="postComment()" style="padding-right: 185px" />
        <span class="d-flex align-items-center customemoji" :style="{ right: '91px', position: 'absolute', 'margin-top': '2px' }" ref="BlackEmojiPicker">
          <CustomEmojiPicker :visible="emojiVisible" :handleVisible="handleEmojiVisible" :insert="insert" />
        </span>
        <font-awesome-icon
          size="2x"
          class="position-absolute"
          :style="{
            right: '135px',
            top: '2px',
            transform: 'scale(0.8)',
            color: '#000000',
          }"
          :icon="['fal', 'camera']"
        />
        <input class="camera-icon-inp cp" type="file" accept="image/png, image/jpeg, image/gif, image/svg+xml" ref="fileInput" @change="handlePicUpload()" />
        <span
          class="position-absolute"
          @click="postComment()"
          :style="{
            display: 'flex',
            'align-self': 'center',
            'z-index': '10',
            right: '24px',
          }"
        >
          <!-- <div class="send-icon">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="paper-plane-top"
                class="svg-inline--fa fa-paper-plane-top"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  :fill="currentCircle.color_code"
                  d="M511.1 255.1c0 12.8-7.625 24.38-19.41 29.41L44.6 477.4c-4.062 1.75-8.344 2.594-12.59 2.594c-8.625 0-17.09-3.5-23.28-10.05c-9.219-9.766-11.34-24.25-5.344-36.27l73.66-147.3l242.1-30.37L77.03 225.6l-73.66-147.3C-2.623 66.3-.4982 51.81 8.72 42.05c9.25-9.766 23.56-12.75 35.87-7.453L492.6 226.6C504.4 231.6 511.1 243.2 511.1 255.1z"
                ></path>
              </svg>
            </div> -->
          <div :style="{ color: getPrimaryColor(), cursor: 'pointer', 'font-weight': '700', 'font-size': '14px', 'line-height': '24px' }">Answer</div>
        </span>
      </div>
    </div>
    <div v-if="isImageUploading" class="d-flex justify-content-center mt-2">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">
        Loading image...
      </div>
    </div>
    <div v-if="fileList.length > 0" class="image-uploading">
      <!-- Image Upload -->
      <a-upload v-if="fileList.length > 0" listType="picture-card" :fileList="fileList" class="position-relative avatar-uploader" @preview="handlePreview" @change="handleChange"></a-upload
      ><a-icon @click="handleChange({ file: fileList, fileList: [] })" :style="{ color: 'red', left: '66px', position: 'absolute' }" type="close-circle" theme="filled" />
    </div>

    <ReportContentModal ref="reportContentModal" />
    <RemoveUserModal ref="removeUserModal" v-on:hideDots="displayDots = false" />
    <SharePostModal ref="sharePostModal" />
    <DeletePostModal ref="deletePostModal" />
  </div>
</template>

<script>
import ReportContentModal from "../../../Modals/ReportContent.vue"
import RemoveUserModal from "../../../Modals/RemoveUser.vue"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import Comment from "./QAComment"
import EmojiPicker from "vue-emoji-picker"
import CustomEmojiPicker from "../../../home/BlackEmojiPicker.vue"
import SharePostModal from "../../../Modals/SharePost"
import s3Upload from "../../../../utilities/imageUploader"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faHeart, faBookmark, faHandsHeart } from "@fortawesome/pro-solid-svg-icons"
import { faCamera, faShare } from "@fortawesome/pro-light-svg-icons"
library.add(faHeart, faBookmark, faHandsHeart, faCamera, faShare)
import DeletePostModal from "../../../Modals/deletePostModal.vue"

const QARepository = RepositoryFactory.get("qa")
const UserRepository = RepositoryFactory.get("user")
const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "UserProfileQuestions",
  components: {
    Comment,
    SharePostModal,
    RemoveUserModal,
    ReportContentModal,
    DeletePostModal,
    CustomEmojiPicker,
  },
  props: {
    quesData: null,
  },
  data() {
    return {
      isImageUploading: false,
      showWritable: true,
      ques: null,
      pagination: null,
      comments: [],
      emojiVisible: false,
      comment_attach: [],
      comment: "",
      fileList: [],
      previewImage: false,
      previewVisible: false,
      currentPage: 1,
      limit: 1,
      comment_count: 0,
      reactions: {
        hugs: false,
        likes: false,
        favorites: false,
      },
      posting: false,
      showRemoveCircleOption: true,
      displayDots: false,
    }
  },

  created() {
    this.ques = this.quesData
    console.log(this.ques, "question")
    this.reactions.hugs = !!this.getReaction(1).length
    this.reactions.likes = !!this.getReaction(2).length
    this.reactions.favorites = !!this.getReaction(4).length
    if (this.ques.comments_count > 0) {
      this.fetchComments()
    }
  },

  methods: {
    handleDeletePostModal(e, post) {
      e.preventDefault()
      this.displayDots = false
      this.$refs.deletePostModal.show(post)
    },
    handleCloseAll() {
      this.displayDots = false
    },
    getInitials() {
      const f = this.authUser.user.first_name
        ? this.authUser.user.first_name[0].toUpperCase()
        : this.authUser.user.display_name
        ? this.authUser.user.display_name[0].toUpperCase()
        : this.authUser.user.email
        ? this.authUser.user.email[0].toUpperCase()
        : ""
      const l = this.authUser.user.last_name ? this.authUser.user.last_name[0].toUpperCase() : ""
      return f + l
    },

    closeEmoji(e) {
      this.emojiVisible = false
    },
    handleEmojiVisible() {
      this.emojiVisible = !this.emojiVisible
    },
    insert(emoji) {
      this.comment += emoji
    },
    active() {
      return "active"
    },
    removeUserFromCircle() {
      UserRepository.removeFromCircle(this.ques.user[0], this.currentCircle.id)
        .then(res => {
          this.displayDots = false
          eventBus.$emit("on-circle")
        })
        .catch(err => {})
    },
    showModel(post) {
      console.log(this.$refs.reportContentModal, post, this.$refs.reportContentModal)
      this.$refs.reportContentModal.show(post, 3)
      this.displayDots = false
    },
    /**
     * View other user profile
     */
    viewProfile() {
      const user = this.ques.user[0]
      if (user.id === this.authUser.user.id) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id, role: 'caregiver' },
                })
                break
              case "doctor":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.id },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateUpdates",
                  params: { id: user.id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {})
      }
      // localStorage.setItem('__ou', JSON.stringify(data))
    },

    /**
     * Fetch comments
     *
     */
    fetchComments(append = false) {
      if (append) {
        this.limit = 5
      }
      QARepository.getComments(this.ques.id, this.currentPage, this.limit, this.currentCircle.id)
        .then(res => {
          this.comment_count += this.limit
          console.log(this.currentPage, this.comment_count, "comment count")
          if (append === true) {
            if (this.currentPage === 1) {
              this.comments.push(...res.data.data.data)
              this.comments.shift()
            } else {
              this.comments.push(...res.data.data.data)
            }
            this.currentPage += 1
            console.log(this.comments)
          } else {
            if (res.data) {
              this.comments = res.data.data.data
              this.pagination = res.data.data.paginator
              console.log(this.comments, this.pagination)
            }
          }
          this.showWritable = true
        })
        .catch(err => {})
    },

    /**
     * Comment on a post
     *
     */
    commentFunction() {
      const payload = {
        question_parent_id: this.ques.id,
        comment_text: this.comment,
        user: this.authUser.user.id,
        comment_attach: this.comment_attach.length ? this.comment_attach : null,
        commented_on_type: 3,
        commented_on_id: this.ques.id,
      }
      if (this.comment.length > 0 || this.comment_attach.length) {
        PostRepository.postComment(payload, this.currentCircle.id)
          .then(res => {
            this.comment = ""
            this.currentPage = 1
            this.ques.comments_count += 1
            this.comment_attach = []
            this.$refs.fileInput.value = ""
            this.comments = []
            this.comment = ""
            this.fileList = []
            this.previewImage = false
            this.previewVisible = false
            this.emojiVisible = false
            this.fetchComments()
          })
          .catch(err => {})
      }
    },
    postComment() {
      if (this.comment.trim().length) {
        this.commentFunction()
      }
      if (this.comment_attach.length > 0) {
        this.commentFunction()
      }
    },

    /**
     * Get reaction of a given type
     *
     * @param {Integer} type
     */
    getReaction(type) {
      let status = []
      if (this.ques.my_reaction.length > 0) {
        status = this.ques.my_reaction.filter(reaction => {
          return reaction.reaction_type === type
        })
      }
      return status
    },
    /**
     * Handle image Upload
     */
    async handlePicUpload() {
      this.isImageUploading = true
      const file = this.$refs.fileInput.files[0]
      try {
        if (file.size / (1024 * 1024) > 1) {
          this.$notification.error({
            message: "Error",
            description: "File size exceeds 1MB limit",
          })
          const input = this.$refs.file
          input.type = "text"
          input.type = "file"
          this.isImageUploading = false
        }
        if (!file.type.includes("image")){
          this.$notification.error({
            message: "Error",
            description: "Please select only image"
          });
          this.isImageUploading = false;
          return;
        }
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        const fileName = urlData.data.data.filename[0]
        await s3Upload(urlData.data.data.url[0], file)
        // this.comment_attach = [fileName]
        this.comment_attach.push(fileName)
        const fileListData = {
          uid: this.comment_attach.length,
          name: file.name,
          status: "done",
          url: urlData.data.data.preview_url,
        }
        this.loading = false
        this.fileList.push(fileListData)
        this.isImageUploading = false
      } catch (err) {}
      this.isImageUploading = false
    },
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },

    async handleChange(data) {
      this.fileList.length === 1 ? (this.fileList = []) : this.fileList.splice(data.file.uid - 1, 1)
      this.comment_attach.splice(data.file.uid - 1, 1)
    },

    /**
     * Reaction to any post/comment. Based on the reaction, send required payload.
     *
     * @param {Object} post
     * @param {Object} event
     */
    react(entity, event, comment = false) {
      const REACTION_TYPES = {
        HUGS: 1,
        LIKE: 2,
        USEFUL: 3,
        FAVORITE: 4,
        FLAGED: 5,
      }

      // const MIRROR_REACTION_TYPES = {
      //   1: 'hug',
      //   2: 'like',
      //   4: 'fav',
      //   5: 'flag'
      // }

      const REACTION_ON = {
        POST: 1,
        COMMENT: 2,
        QUESTION: 3,
        ARTICLE: 4,
      }
      if (this.posting) {
        return
      }
      let path = event.path || (event.composedPath && event.composedPath())
      const type = event.target.id ? event.target.id : path[1]["id"]

      switch (type) {
        case "hugs":
          this.reactions.hugs ? this.deleteReaction(REACTION_TYPES.HUGS, type) : this.saveReaction(entity.id, REACTION_TYPES.HUGS, REACTION_ON.QUESTION)
          break
        case "likes":
          this.reactions.likes ? this.deleteReaction(REACTION_TYPES.LIKE, type) : this.saveReaction(entity.id, REACTION_TYPES.LIKE, REACTION_ON.QUESTION)
          break
        case "favorites":
          this.reactions.favorites ? this.deleteReaction(REACTION_TYPES.FAVORITE, type) : this.saveReaction(entity.id, REACTION_TYPES.FAVORITE, REACTION_ON.QUESTION)
          break
        case "flag":
          this.reactions.flag ? this.deleteReaction(REACTION_TYPES.FLAGED, type) : this.saveReaction(entity.id, REACTION_TYPES.FLAGED, REACTION_ON.QUESTION)
          break
        default:
          break
      }
    },

    /**
     * Delete reaction to post
     *
     * @param {Integer} reactionId
     */
    deleteReaction(reactionId, type) {
      this.posting = true
      console.log("deleting reaction")
      const reactions = this.getReaction(reactionId)

      let ids = ""
      ids = reactions.map(reaction => {
        return reaction.id
      })

      const user = JSON.parse(localStorage.getItem("user"))
      const headers = {
        Authorization: `Bearer ${user.user.token}`,
      }
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${ids.toString()}`, { headers })
        .then(res => {
          this.reactions[type] = false
          this.posting = false
          if (this.ques.reaction[type] > 0) {
            this.ques.reaction[type] -= 1
          }
        })
        .catch(err => {
          this.posting = false
        })
    },

    /**
     * Save reaction to post
     *
     * @param {Integer} postId
     * @param {Integer} reactionType
     * @param {Integer} reactionOnType
     */
    saveReaction(postId, reactionType, reactionOnType) {
      const MIRROR_REACTION_TYPES = {
        1: "hugs",
        2: "likes",
        4: "favorites",
      }
      this.posting = true
      const payload = {
        reacted_on_type: reactionOnType,
        reacted_on_id: postId,
        user: this.authUser.user.id,
        reaction_type: reactionType,
      }

      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => {
          this.posting = false
          this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true
          this.ques.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1
          const index = this.ques.my_reaction.findIndex(rs => rs.reaction_type === reactionType)
          if (index >= 0) {
            this.ques.my_reaction.splice(index, 1)
          }
          this.ques.my_reaction.push(res.data.data)
        })
        .catch(err => {
          this.posting = false
        })
    },
    fetchUser(e) {
      e.preventDefault()
      const user = this.ques.user[0]
      UserRepository.getOtherUserProfile(user, this.currentCircle.id).then(res => {
        const onCircle = res.data.data.on_circle

        if (!onCircle) {
          this.displayDots = !this.displayDots
          this.showRemoveCircleOption = false
        } else {
          this.displayDots = !this.displayDots
        }
      })
    },

    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dot-menu-cont {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  // height: 50%;
}

.fa-camera {
  width: 35px;
  height: 35px;
  position: relative;
  vertical-align: text-top;
  cursor: pointer;
}

.camera-icon-inp {
  opacity: 0;
  position: absolute;
  right: 135px;
  top: 2px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 5;

  &::-webkit-file-upload-button {
    opacity: 0;
    position: absolute;
    right: 55px;
    top: 5px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 5;
  }
}
.sub-text {
  font-size: 16px !important;
}
.image-uploading {
  height: auto;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}
.post__tags {
  margin-bottom: 20px;
  // display: flex;
  .tags {
    padding: 3px 16px;
    display: inline-block;
    font-weight: 700;
    font-size: 10px;
    margin-right: 5px;
  }
  .popover-button {
    margin: 5px;

    button {
      background: none;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/QA/UserProfileQuestions.vue